import { Expose } from "class-transformer";

export class UpdatePlanningBoardCommentsDto {
  @Expose()
  comments: string | null;
}
